import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AutoInvestComponent} from './auto-invest.component';
import {AuthGuard, BorrowerObstructGuard} from '../../auth.guard';
import {PortfolioCreationDataResolver} from '../resolvers/portfolio-creation-data-resolver';

const routes: Routes = [{
    path: '',
    pathMatch: 'full',
    component: AutoInvestComponent,
    resolve: {
        portfolioCreationData: PortfolioCreationDataResolver
    },
}];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)],
    providers: [AuthGuard, BorrowerObstructGuard]
})
export class AutoInvestRoutingModule {
}